import type { TabsProps } from "@mantine/core";
import { Tabs } from "@mantine/core";

export const StyledTabs = (props: TabsProps) => {
  return (
    <Tabs
      unstyled
      styles={(theme) => {
        return {
          tab: {
            ...theme.fn.focusStyles(),

            "&:disabled": {
              cursor: "not-allowed",
              opacity: 0.5,
            },

            "&:not(:first-of-type)": {
              marginLeft: "4px",
            },

            "&[data-active]": {
              backgroundColor: "#fff",
              color: "#2D3336",
            },
            alignItems: "center",
            backgroundColor: "#DFF7FB",
            borderRadius: "8px 8px 0px 0px",
            color: "#00A5B9",
            cursor: "pointer",

            display: "flex",
            fontSize: theme.fontSizes.sm,
            padding: "12px 16px",
          },

          tabIcon: {
            alignItems: "center",
            display: "flex",
            marginRight: "5px",
          },

          tabsList: {
            // スクロールバー非表示（Chrome・Safari
            "&::-webkit-scrollbar": {
              display: "none",
            },
            display: "flex",
            // スクロールバー非表示（IE・Edge）
            msOverflowStyle: "none",
            // tabを横スクロール
            overflowX: "scroll",
            // スクロールバー非表示（Firefox
            scrollbarWidth: "none",
            whiteSpace: "nowrap",
          },
        };
      }}
      {...props}
    />
  );
};
